import styled from '@emotion/styled';
import type { Reader } from '@racemap/utilities/types/types';
import type { FC } from 'react';
import { ReadersListEntry } from './ReadersListEntry';

interface ReadersListProps {
  readers: Array<Reader>;
  readerInFocus: Reader | null;
  onReaderInFocusChange: (reader: Reader | null) => void;
  onReaderInFocusClick?: (reader: Reader) => void;
}

export const ReadersList: FC<ReadersListProps> = ({
  readers,
  readerInFocus,
  onReaderInFocusChange,
  onReaderInFocusClick,
}) => {
  return (
    <List>
      {readers
        .sort((a, b) => {
          return (
            (a.mappings[0]?.offset ?? Number.POSITIVE_INFINITY) -
            (b.mappings[0]?.offset ?? Number.POSITIVE_INFINITY)
          );
        })
        .map((reader, index) => {
          return (
            <ReadersListEntry
              key={reader.readerId}
              index={index}
              reader={reader}
              focused={reader.readerId === readerInFocus?.readerId}
              onEnter={() => onReaderInFocusChange(reader)}
              onLeave={() => onReaderInFocusChange(null)}
              onReaderClick={onReaderInFocusClick}
            />
          );
        })}
    </List>
  );
};

const List = styled.div`
  position: absolute;
  overflow: auto;
  grid-area: list;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
`;
